<ng-container *ngIf="component.data$ | async as data">
  <ng-container *ngIf="data.urlLink?.length">
    <cx-generic-link
      [class]="'text-decoration-none focusable focusable__element d-block'"
      [target]="isExternalLink(data.external) ? '_blank' : '_self'"
      [title]="data.media?.altText"
      [url]="data.urlLink"
    >
      <ng-container *ngTemplateOutlet="banner; context: {$implicit: data}"></ng-container>
    </cx-generic-link>
  </ng-container>
  <ng-container *ngIf="!data.urlLink?.length">
    <div [class]="'text-decoration-none focusable focusable__element d-block'">
      <ng-container *ngTemplateOutlet="banner; context: {$implicit: data}"></ng-container>
    </div>
  </ng-container>
</ng-container>

<ng-template #banner let-data>
  <div class="d-flex align-items-center" data-cy="sap-logo">
    <div class="media-wrapper my-0">
      <cx-media [container]="data.media" [format]="'desktop'" class="d-flex align-items-center"></cx-media>
    </div>
    <span *ngIf="data.headline" [innerHTML]="data.headline"
          class="body--s">
      </span>
  </div>
</ng-template>
